// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"19c73583","507":"ecd455de","763":"9ec16995","824":"47e56a1e","955":"8190f096","988":"47e56a1e"}[chunkId] + ".chunk.css";
};